import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full flex justify-between items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-4xl text-primary-700 font-bold" }, "Notifications", -1)
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = {
  key: 0,
  class: "has-notif w-4 h-4 absolute right-0 top-0 border-4 border-white rounded-full bg-red-700"
}
const _hoisted_5 = { class: "bg-white rounded-lg min-h-[calc(100%-100px)]" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "text-xs text-gray-400 font-bold mb-2 date" }
const _hoisted_8 = { class: "text-gray-400 title mb-2" }
const _hoisted_9 = { class: "desc text-gray-400" }

import PortalLayout from '@/layouts/PortalLayout.vue';
import { BellIcon } from '@heroicons/vue/24/outline';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';

import PatientNotification from "@/classes/PatientNotification";

import { useRouter } from 'vue-router';
import { onMounted, ref, computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const router = useRouter();

// Data
const loader    = ref(false);
const showError = ref(false);
const errorMsg  = ref(null);

const items = ref(null);
const item = ref(null);
const unreadCounts = ref(0);

// Methods
const indexPatientNotification = () => {
    loader.value = true;

    PatientNotification.indexPatientNotification()
        .then((response: any) => {
            loader.value = false;

            items.value = response.data.notifications;
            unreadCounts.value = items.value.filter(x => x.read_at == null).length;
        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;
            
            if(err.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

const markRead = (id) => {
    loader.value = true;

    PatientNotification.readPatientNotification(id)
        .then((response: any) => {
            loader.value = false;

            items.value = response.data.notifications;
            item.value = response.data.notification;
            unreadCounts.value = items.value.filter(x => x.read_at == null).length;
            
            // Redirect After Read
            redirect(item.value);
        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;
            
            if(err.response.status == 401) {
                window.location.replace('/login');
            }
        })
}


const markReadAll = () => {
    loader.value = true;

    PatientNotification.readAllPatientNotification()
        .then((response: any) => {
            loader.value = false;

            items.value = response.data.notifications;
            unreadCounts.value = items.value.filter(x => x.read_at == null).length;
        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;
            
            if(err.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

const redirect = (item : any) => {
    if(item.data.subject_type) {
        switch (item.data.subject_type) {
            case 'Booking':
                window.location.replace(`/appointment/show/${item.data.subject_id}`);
                break;
            case 'Pending Booking':
                window.location.replace(`/booking`);
                break;
            case 'Patient':
                window.location.replace(`/account-details`);
                break;
            default:
                break;
        }
    }
}

onMounted( () => {
    indexPatientNotification();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PortalLayout, {
    notifCount: 0,
    defaultTitle: false
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(BellIcon), {
            class: "w-7 h-7 cursor-pointer",
            onClick: _withModifiers(markReadAll, ["prevent"])
          }, null, 8, ["onClick"]),
          (unreadCounts.value > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["p-5 border-b last:border-b-0 border-[#EEEEEE] relative notification-card cursor-pointer bg-white", item.read_at ? '' : 'new']),
            onClick: _withModifiers(($event: any) => (markRead(item.id)), ["prevent"])
          }, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(item.created_at), 1),
            _createElementVNode("p", _hoisted_8, _toDisplayString(item.data.title), 1),
            _createElementVNode("p", _hoisted_9, _toDisplayString(item.data.message), 1)
          ], 10, _hoisted_6))
        }), 128))
      ]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[0] || (_cache[0] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[1] || (_cache[1] = ($event: any) => (showError.value = false))
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})